/**
 * Returns a markdown link with proper escaping
 */
export function toMarkdownLink(title: string, url: string): string {
    const escapedTitle = title.replace(/]/g, '\\]');
    const escapedUrl = url.replace(/\)/g, '\\)');
    return `[${escapedTitle}](${escapedUrl})`;
}
